import { __decorate, __metadata } from "tslib";
import { Type } from "class-transformer";
import { v4 as uuidv4 } from "uuid";
import AppsListingModel, { IAppsGridViewDTO } from "../productsApps/AppsListingDTO";
let ProductsViewModel = /** @class */ (() => {
    var _a;
    class ProductsViewModel {
        constructor() {
            this.id = uuidv4();
            this.name = "";
            this.description = "";
            this.owner = "";
            this.startedYear = "";
            this.domain = "";
        }
    }
    __decorate([
        Type(() => AppsListingModel),
        __metadata("design:type", typeof (_a = typeof IAppsGridViewDTO !== "undefined" && IAppsGridViewDTO) === "function" ? _a : Object)
    ], ProductsViewModel.prototype, "appsDTO", void 0);
    return ProductsViewModel;
})();
export { ProductsViewModel };
export default class Products extends ProductsViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
